import { render } from "./ApuracaoCaixaIndex.vue?vue&type=template&id=4a4a2e96&scoped=true&ts=true"
import script from "./ApuracaoCaixaIndex.vue?vue&type=script&lang=ts"
export * from "./ApuracaoCaixaIndex.vue?vue&type=script&lang=ts"

import "./ApuracaoCaixaIndex.vue?vue&type=style&index=0&id=4a4a2e96&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4a2e96"]])

export default __exports__